// extracted by mini-css-extract-plugin
module.exports = {"short_input":"short_input--2fnXw","large_input":"large_input--2ge1I","text_area":"text_area--1Gzjx"};